<template>
  <article
    :class="{ 'load load--fill min-h-screen': isLoading }"
    class="card"
  >
    <header class="text-center py-3">
      <h1
        class="text-grey-darkest text-lg1"
        v-text="blog.attributes.title"
      />
      <p v-if="!isLoading">
        <AuthorName
          :full-name="blog.author.attributes.full_name"
          :is-a-shared-copy="blog.attributes.is_a_shared_copy"
          :sharing-union-name="blog.attributes.sharing_union_name"
        />
        {{ publicationDateText }}
        {{ publicationDate }}
      </p>
      <CommPopper
        ref="commPopper"
        v-can="['edit-blog-entries', 'archive-blog-entries', 'delete-blog-entries', 'share-comms']"
        :options="{ placement: 'bottom-end' }"
      >
        <div
          slot="content"
          class="flex flex-col"
        >
          <a
            v-can="'edit-blog-entries'"
            :href="editUrl"
            v-text="'Edit'"
          />
          <a
            v-if="blog.attributes.status !== 'archived'"
            v-can="'archive-blog-entries'"
            href="#"
            @click.prevent="$refs.commPopper.close().then($store.commit('communicationOpenArchiveBlogEntryModal', blog))"
            v-text="'Archive'"
          />
          <a
            v-can="'share-comms'"
            href="#"
            @click.prevent="$refs.commPopper.close().then($root.openModalWithPayload('sendCommToOrganizationsModal', blog))"
            v-text="'Share with Organization'"
          />
          <a
            v-can="'delete-blog-entries'"
            href="#"
            @click.prevent="$refs.commPopper.close().then($store.commit('communicationOpenDeleteBlogEntryModal', blog))"
            v-text="'Delete'"
          />
        </div>
      </CommPopper>
    </header>
    <div class="card-content mx-auto">
      <div
        v-if="blog.attributes.hero_image"
        class="mb-8 card-header-image"
      >
        <img
          :src="blog.attributes.hero_image"
          alt=""
        >
      </div>
      <span
        class="js-fitvids"
        v-html="blog.attributes.body"
      />
      <div
        v-if="categories.length"
        class="px-6 py-4"
      >
        <span v-text="'Categories:'" />
        <span
          v-for="category in categories"
          :key="category.uuid"
          class="inline-block bg-grey-lighter rounded-full px-3 py-1 text-sm font-semibold text-grey-darker mr-2"
          v-text="category.attributes.title"
        />
      </div>
    </div>
    <ArchiveBlogEntryModal @archived="$store.dispatch('communicationSetBlogEntry', blogUuid)" />
    <DeleteBlogEntryModal @destroyed="redirect" />
    <SendCommToOrganizations />
  </article>
</template>

<script type="text/babel">
import fitvids from 'fitvids'
import ArchiveBlogEntryModal from './_modals/ArchiveBlogEntryModal'
import DeleteBlogEntryModal from './_modals/DeleteBlogEntryModal'
import SendCommToOrganizations from './_modals/SendCommToOrganizationsModal'
import AuthorName from './SharedCommunicationAuthorName'
import CommPopper from './CommPopper'

export default {
  name: 'BlogEntryDetails',
  components: {
    AuthorName,
    CommPopper,
    DeleteBlogEntryModal,
    ArchiveBlogEntryModal,
    SendCommToOrganizations,
  },
  props: {
    blogUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    blog() {
      return this.$store.state.communication.blogEntry
    },
    publicationDate() {
      return this.moment(this.blog.attributes.publication_date).format(this.$root.commDateFormat)
    },
    editUrl() {
      return this.$urlGenerator.active(`communications/blog/${this.blogUuid}/edit`)
    },
    categories() {
      return this.blog.categories.data
    },
    publicationDateText() {
      return this.moment(this.blog.attributes.publication_date).isAfter()
        ? 'scheduled for publication on'
        : 'published at'
    },
  },
  async mounted() {
    await this.$nextTick()

    this.isLoading = true

    this.$store.dispatch('communicationSetBlogEntry', this.blogUuid)
      .then(() => {
        this.isLoading = false
      })
  },
  updated() {
    fitvids('.js-fitvids')
  },
  methods: {
    redirect() {
      window.location.replace(this.$urlGenerator.active('communications'))
    },
  },
}
</script>
